var _Divider;
import React from 'react';
import { string } from 'prop-types';
import clsx from 'clsx';
import { alpha, styled } from '@mui/material/styles';
import SovosDivider from '../../../sovos-divider';
import SovosTypography from '../../../sovos-typography';
import SovosFixedWidthText from '../../../sovos-fixed-width-text';
const Header = styled('li')(_ref => {
  let {
    theme: {
      spacing,
      typography
    }
  } = _ref;
  return {
    alignItems: 'center',
    display: 'flex',
    height: typography.body2.fontSize * typography.body2.lineHeight,
    margin: spacing(),
    '&.sovosNavigationLinks__sectionHeader--hasLabel': {
      margin: "".concat(spacing(3), " ").concat(spacing(), " ").concat(spacing(), " ").concat(spacing())
    }
  };
});
const HeaderLabel = styled(SovosTypography)(_ref2 => {
  let {
    theme: {
      palette,
      spacing
    }
  } = _ref2;
  return {
    color: alpha(palette.primary.light, 0.75),
    margin: "0 ".concat(spacing()),
    maxWidth: '100%',
    textTransform: 'uppercase'
  };
});
const Divider = styled(SovosDivider)(_ref3 => {
  let {
    theme: {
      palette
    }
  } = _ref3;
  return {
    borderColor: alpha(palette.primary.light, 0.5),
    flex: '1 1 auto'
  };
});
const SectionHeader = _ref4 => {
  let {
    label
  } = _ref4;
  return /*#__PURE__*/React.createElement(Header, {
    key: label,
    className: clsx('sovosNavigationLinks__sectionHeader', label != null && 'sovosNavigationLinks__sectionHeader--hasLabel')
  }, label == null ? null : /*#__PURE__*/React.createElement(HeaderLabel, {
    variant: "body2",
    component: "h6"
  }, /*#__PURE__*/React.createElement(SovosFixedWidthText, {
    text: label
  })), _Divider || (_Divider = /*#__PURE__*/React.createElement(Divider, null)));
};
SectionHeader.propTypes = {
  label: string
};
export default SectionHeader;